/* istanbul ignore file */

import { Breakpoint } from './constants';
import { useMediaQuery } from './useMediaQuery';
import { QueryOptions } from './generateMediaQuery';

export const usePhone = (options?: QueryOptions) => useMediaQuery(Breakpoint.PHONE, options);
export const useTablet = (options?: QueryOptions) => useMediaQuery(Breakpoint.TABLET, options);
export const useDesktop = (options?: QueryOptions) => useMediaQuery(Breakpoint.DESKTOP, options);
export const useWide = (options?: QueryOptions) => useMediaQuery(Breakpoint.WIDE, options);
